import { useEffect, useState } from 'react';
import { Button } from '@vinted/web-ui';
import { debounce } from 'lodash';
import classNames from 'classnames';
import { ShowAtBreakpoint } from 'components/Breakpoint';
import { jsx as _jsx } from "react/jsx-runtime";
const SCROLL_DEBOUNCE = 250;

const BackToTopButton = () => {
  const {
    0: isScrollToTopButtonVisible,
    1: setIsScrollToTopButtonVisible
  } = useState(false);
  const containerClassName = classNames('back-to-top-button', {
    'back-to-top-button--visible': isScrollToTopButtonVisible
  });
  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 0) {
        setIsScrollToTopButtonVisible(true);
      } else {
        setIsScrollToTopButtonVisible(false);
      }
    };

    const watchScroll = () => {
      window.addEventListener('scroll', debounce(handleScroll, SCROLL_DEBOUNCE));
    };

    watchScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return /*#__PURE__*/_jsx(ShowAtBreakpoint, {
    breakpoint: "phones",
    children: /*#__PURE__*/_jsx("div", {
      className: containerClassName,
      children: /*#__PURE__*/_jsx(Button, {
        deprecatedIconName: "chevron-up",
        inline: true,
        onClick: scrollToTop
      })
    })
  });
};

export default BackToTopButton;